import Dexie from 'dexie';

// Reason: Schema strings verbatim from offline-pwa-phase-1.md §3.1.
// Primary keys + indexed mirror fields enumerated here; payload column
// holds the raw API response.
export const db = new Dexie('rin-cache');

db.version(1).stores({
  articles: 'id, fetched_at, last_opened_at, is_read',
  daily_briefings: 'date, fetched_at',
  topic_digests: 'topic_id, fetched_at',
  highlights: 'id, article_id, fetched_at',
  meta: 'key',
});

db.version(2).stores({
  articles: 'id, fetched_at, last_opened_at, is_read',
  daily_briefings: 'date, fetched_at',
  topic_digests: 'topic_id, fetched_at',
  highlights: 'id, article_id, fetched_at',
  meta: 'key',
  image_cache_meta: 'url, last_accessed, size_bytes',
});

db.version(3).stores({
  articles: 'id, fetched_at, last_opened_at, is_read',
  daily_briefings: 'date, fetched_at',
  topic_digests: 'topic_id, fetched_at',
  highlights: 'id, article_id, fetched_at',
  meta: 'key',
  image_cache_meta: 'url, last_accessed, size_bytes',
  mutation_log: 'key, status, type, created_at, [status+created_at]',
});

// Reason: pending_key on highlights needed for local row readback after
// highlight_create mutations (useHighlights reads back by pending_key UUID).
db.version(4).stores({
  articles: 'id, fetched_at, last_opened_at, is_read',
  daily_briefings: 'date, fetched_at',
  topic_digests: 'topic_id, fetched_at',
  highlights: 'id, article_id, fetched_at, pending_key',
  meta: 'key',
  image_cache_meta: 'url, last_accessed, size_bytes',
  mutation_log: 'key, status, type, created_at, [status+created_at]',
});

// Reason: paged_views holds lightweight page indexes (ordered article IDs +
// pagination metadata) for offline list rendering — design §7. Additive: all
// v4 tables are re-declared unchanged so Dexie preserves their data.
db.version(5).stores({
  articles: 'id, fetched_at, last_opened_at, is_read',
  daily_briefings: 'date, fetched_at',
  topic_digests: 'topic_id, fetched_at',
  highlights: 'id, article_id, fetched_at, pending_key',
  meta: 'key',
  image_cache_meta: 'url, last_accessed, size_bytes',
  mutation_log: 'key, status, type, created_at, [status+created_at]',
  paged_views: 'key, fetched_at',
});

export default db;
